
[
  {
    "id": "TIJD-PAT-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Kijk naar de rij: 3 - 7 - 11 - 15 - ... Welk getal komt daarna?",
    "options": ["19", "16", "18", "20"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "patronen",
    "familyId": "TIJD-PAT-REEKS",
    "explanation": "De getallen springen steeds 4 verder. Kijk: 3 + 4 = 7, 7 + 4 = 11, 11 + 4 = 15. Dus na 15 komt 19.",
    "distractorExplanations": {
      "1": "Je deed +1. Maar de sprongen zijn +4!",
      "2": "Je deed +3. Maar kijk goed: van 3 naar 7 is +4!",
      "3": "Je deed +5. Maar de sprongen zijn +4: 3, 7, 11, 15, 19."
    },
    "visualAid": {
      "type": "numberline",
      "data": { "start": 0, "end": 24, "highlight": [3, 7, 11, 15, 19], "label": "Patroon: +4" },
      "showWhen": "wrong"
    }
  },
  {
    "id": "TIJD-TAB-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "In een tabel staat: Maandag 5 graden, Dinsdag 8 graden, Woensdag 6 graden. Op welke dag was het het warmst?",
    "options": ["Dinsdag", "Maandag", "Woensdag", "Alle dagen gelijk"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-TEMPERATUUR",
    "explanation": "8 is het hoogste getal. Dus op dinsdag was het het warmst.",
    "distractorExplanations": {
      "1": "5 graden is kouder dan 8 graden.",
      "2": "6 graden is kouder dan 8 graden.",
      "3": "De getallen zijn verschillend: 5, 8 en 6."
    },
    "visualAid": {
      "type": "ratio",
      "data": { "headers": ["Dag", "Temperatuur"], "rows": [["Maandag", "5°C"], ["Dinsdag", "8°C"], ["Woensdag", "6°C"]], "highlightRow": 1 },
      "showWhen": "wrong"
    }
  },
  {
    "id": "TIJD-TAB-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Voetbalstand: Ajax 12 punten, PSV 15 punten, Feyenoord 10 punten. Welk team staat bovenaan?",
    "options": ["PSV", "Ajax", "Feyenoord", "Alle gelijk"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-PUNTEN",
    "explanation": "PSV heeft 15 punten. Dat is meer dan Ajax (12) en Feyenoord (10).",
    "distractorExplanations": {
      "1": "Ajax heeft 12 punten. Dat is minder dan PSV (15).",
      "2": "Feyenoord heeft 10 punten. Dat is het minst.",
      "3": "De punten zijn niet gelijk: 12, 15 en 10."
    }
  },
  {
    "id": "TIJD-TAB-L1-003",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Lengte tabel: Lisa 145 cm, Tom 152 cm, Emma 148 cm. Wie is het langst?",
    "options": ["Tom", "Lisa", "Emma", "Lisa en Emma"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-LENGTE",
    "explanation": "Tom is 152 cm. Dat is langer dan Lisa (145) en Emma (148).",
    "distractorExplanations": {
      "1": "Lisa is 145 cm. Dat is korter dan Tom (152).",
      "2": "Emma is 148 cm. Dat is korter dan Tom (152).",
      "3": "Lisa en Emma zijn niet even lang: 145 en 148 cm."
    }
  },
  {
    "id": "TIJD-DUR-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Het is nu 14:00. Over een kwartier is het...",
    "options": ["14:15", "14:30", "15:00", "14:45"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-DUR-KWARTIER",
    "explanation": "Een kwartier is 15 minuten. 14:00 + 15 minuten = 14:15.",
    "distractorExplanations": {
      "1": "Een half uur is 30 minuten, niet een kwartier (15 minuten).",
      "2": "Een uur is 60 minuten, niet een kwartier (15 minuten).",
      "3": "Driekwartier is 45 minuten, niet een kwartier (15 minuten)."
    }
  },
  {
    "id": "TIJD-DUR-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "De film begint om 19:30 en duurt 1 uur. Hoe laat is de film afgelopen?",
    "options": ["20:30", "20:00", "21:00", "19:00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-DUR-HALF-UUR",
    "explanation": "De film begint om 19:30 en duurt 1 uur. 19:30 + 1 uur = 20:30.",
    "distractorExplanations": {
      "1": "Je bent maar een half uur verder gegaan. De film duurt 1 uur!",
      "2": "Je bent 1,5 uur verder gegaan. De film duurt maar 1 uur.",
      "3": "Je bent teruggegaan in plaats van vooruit!"
    }
  },
  {
    "id": "TIJD-KLOK-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Hoeveel seconden zitten er in 1 minuut?",
    "options": ["60 seconden", "100 seconden", "30 seconden", "120 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TIJD-KLOK-SECONDE-BASIS",
    "explanation": "1 minuut heeft 60 seconden. Dit moet je uit je hoofd kennen!",
    "distractorExplanations": {
      "1": "100 seconden is te veel. 1 minuut = 60 seconden.",
      "2": "30 seconden is een half minuut.",
      "3": "120 seconden is 2 minuten."
    },
    "visualAid": {
      "type": "rule",
      "data": { "title": "Tijd Omrekenen", "content": "1 minuut = 60 seconden. Onthoud dit goed!", "icon": "lightbulb" },
      "showWhen": "wrong"
    }
  },
  {
    "id": "TIJD-KLOK-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "De digitale klok toont: 14:30:00. Hoe laat is het?",
    "options": ["Half drie 's middags", "Half twee 's middags", "Drie uur 's middags", "Half vier 's middags"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "klokkijken",
    "subSkill": "klokkijken_digitaal",
    "familyId": "TIJD-KLOK-DIGITAAL",
    "explanation": "14:30:00 betekent 14 uur en 30 minuten (en 0 seconden). 14:30 is half drie 's middags.",
    "distractorExplanations": {
      "1": "Half twee is 13:30, niet 14:30.",
      "2": "Drie uur is 15:00, niet 14:30.",
      "3": "Half vier is 15:30, niet 14:30."
    }
  },
  {
    "id": "TIJD-KLOK-L1-003",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Hoeveel seconden zitten er in een half minuut?",
    "options": ["30 seconden", "60 seconden", "15 seconden", "45 seconden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TIJD-KLOK-HALF-MINUUT",
    "explanation": "Een half minuut is de helft van 60 seconden. 60 : 2 = 30 seconden.",
    "distractorExplanations": {
      "1": "60 seconden is een hele minuut, niet een half.",
      "2": "15 seconden is een kwart minuut.",
      "3": "45 seconden is driekwart minuut."
    }
  },
  {
    "id": "TIJD-KLOK-INT-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Hoe laat is het op de klok? (gebruik 24-uurs notatie)",
    "options": ["14:30:00", "02:30:00", "14:06:00", "15:30:00"],
    "correctAnswer": 0,
    "questionType": "klok_aflezen",
    "skill": "klokkijken",
    "subSkill": "klokkijken_seconden",
    "familyId": "TIJD-KLOK-INT-BASIS",
    "context": "Het is 's middags. De school is net uit.",
    "explanation": "Het is 's middags, dus we gebruiken de 24-uurs notatie. De kleine wijzer staat tussen de 2 en 3 (dus 14 uur). De grote wijzer staat op de 6 (30 minuten). Antwoord: 14:30:00.",
    "distractorExplanations": {
      "1": "02:30 is 's nachts. Maar de context zegt dat het 's middags is!",
      "2": "Je hebt de cijfers op de klok gelezen (6) in plaats van de minuten (30).",
      "3": "Je hebt de uren verkeerd afgelezen. De kleine wijzer is nog niet bij de 3."
    }
  },
  {
    "id": "GELD-SAMEN-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Maak precies €1,50",
    "options": ["100", "50", "20", "10", "5"],
    "correctAnswer": 150,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-BASIC-1",
    "explanation": "Je moet €1,50 maken. Dat is 150 cent. Bijvoorbeeld: €1 + 50 cent = €1,50.",
    "distractorExplanations": {
      "1": "Je hebt te weinig gekozen. Tel je munten nog eens na.",
      "2": "Je hebt te veel gekozen. Haal wat munten weg.",
      "3": "Je bent 50 cent vergeten. Voeg een munt van 50 cent toe.",
      "4": "Je bent €1 vergeten. Voeg een munt van €1 toe."
    }
  },
  {
    "id": "GELD-SAMEN-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Maak precies €2,50",
    "options": ["200", "100", "50", "20", "10"],
    "correctAnswer": 250,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-BASIC-2",
    "explanation": "Je moet €2,50 maken. Dat is 250 cent. Bijvoorbeeld: €2 + 50 cent = €2,50.",
    "distractorExplanations": {
      "1": "Je hebt te weinig gekozen. €2,50 is 250 cent.",
      "2": "Je hebt te veel gekozen. Tel je munten nog eens na.",
      "3": "Je bent 50 cent vergeten.",
      "4": "Je bent €1 vergeten."
    }
  },
  {
    "id": "GELD-SAMEN-L1-003",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Maak precies €3,75",
    "options": ["200", "100", "50", "20", "10", "5"],
    "correctAnswer": 375,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "GELD-SAMEN-BASIC-3",
    "explanation": "Je moet €3,75 maken. Bijvoorbeeld: €2 + €1 + 50 cent + 20 cent + 5 cent = €3,75.",
    "distractorExplanations": {
      "1": "Je hebt te weinig gekozen. €3,75 is 375 cent.",
      "2": "Je hebt te veel gekozen. Tel je munten nog eens na.",
      "3": "Je bent 50 cent vergeten.",
      "4": "Je bent €1 vergeten."
    }
  },
  {
    "id": "GELD-WISSEL-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Je koopt iets van € 3,00 en betaalt met € 5,00. Maak het wisselgeld",
    "options": ["200", "100", "50", "20", "10", "5"],
    "correctAnswer": 200,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-SIMPEL-1",
    "explanation": "Je betaalt €5 voor iets van €3. Wisselgeld: €5 - €3 = €2.",
    "distractorExplanations": {
      "1": "Je hebt te weinig wisselgeld gemaakt. €5 - €3 = €2.",
      "2": "Je hebt te veel wisselgeld gemaakt. €5 - €3 = €2.",
      "3": "Je bent 50 cent vergeten of hebt verkeerd geteld.",
      "4": "Je bent €1 vergeten of hebt verkeerd geteld."
    }
  },
  {
    "id": "GELD-WISSEL-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Een broodje kost € 2,50. Je betaalt met € 5,00. Maak het wisselgeld",
    "options": ["200", "100", "50", "20", "10", "5"],
    "correctAnswer": 250,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-SIMPEL-2",
    "explanation": "Je betaalt €5 voor iets van €2,50. Wisselgeld: €5 - €2,50 = €2,50.",
    "distractorExplanations": {
      "1": "Je hebt te weinig wisselgeld gemaakt. €5 - €2,50 = €2,50.",
      "2": "Je hebt te veel wisselgeld gemaakt. €5 - €2,50 = €2,50.",
      "3": "Je bent 50 cent vergeten.",
      "4": "Je bent €1 vergeten."
    }
  },
  {
    "id": "GELD-WISSEL-L1-003",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Je betaalt € 1,50 voor een pen met een briefje van € 2,00. Maak het wisselgeld",
    "options": ["50", "20", "10", "5", "2", "1"],
    "correctAnswer": 50,
    "questionType": "geld_samenstellen",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "GELD-WISSEL-SIMPEL-3",
    "explanation": "Je betaalt €2 voor iets van €1,50. Wisselgeld: €2 - €1,50 = €0,50.",
    "distractorExplanations": {
      "1": "Je hebt te weinig wisselgeld gemaakt. €2 - €1,50 = €0,50.",
      "2": "Je hebt te veel wisselgeld gemaakt. €2 - €1,50 = €0,50.",
      "3": "Je bent 50 cent vergeten.",
      "4": "Je hebt verkeerd geteld."
    }
  },
  {
    "id": "GELD-PRIJS-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Een appel kost € 0,50. Een banaan kost € 0,35. Wat is goedkoper?",
    "options": ["Banaan", "Appel", "Even duur", "Kan niet zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "GELD-PRIJS-SIMPEL-1",
    "explanation": "Een banaan kost €0,35 en een appel €0,50. €0,35 < €0,50, dus de banaan is goedkoper.",
    "distractorExplanations": {
      "1": "De appel kost €0,50. Dat is duurder dan de banaan (€0,35).",
      "2": "De prijzen zijn niet gelijk: €0,50 ≠ €0,35.",
      "3": "Je kunt het wel zeggen! Vergelijk de prijzen."
    }
  },
  {
    "id": "GELD-PRIJS-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Winkel A: melk € 1,20. Winkel B: melk € 1,50. Waar is het goedkoper?",
    "options": ["Winkel A", "Winkel B", "Even duur", "Winkel A en B"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "GELD-PRIJS-SIMPEL-2",
    "explanation": "Winkel A: €1,20. Winkel B: €1,50. €1,20 < €1,50, dus Winkel A is goedkoper.",
    "distractorExplanations": {
      "1": "Winkel B is duurder (€1,50 > €1,20).",
      "2": "De prijzen zijn niet gelijk: €1,20 ≠ €1,50.",
      "3": "Je moet kiezen: Winkel A is goedkoper."
    }
  },
  {
    "id": "GELD-BOOD-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Je koopt brood voor € 2,00 en melk voor € 1,50. Wat is het totaal?",
    "options": ["€ 3,50", "€ 3,00", "€ 4,00", "€ 2,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "GELD-BOOD-SIMPEL-1",
    "explanation": "Brood €2,00 + melk €1,50 = €3,50.",
    "distractorExplanations": {
      "1": "Je bent 50 cent vergeten. €2,00 + €1,50 = €3,50.",
      "2": "Je hebt 50 cent te veel geteld. €2,00 + €1,50 = €3,50.",
      "3": "Je bent €1 vergeten. €2,00 + €1,50 = €3,50."
    }
  },
  {
    "id": "GELD-BOOD-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Een appel kost € 0,50. Je koopt 4 appels. Hoeveel betaal je?",
    "options": ["€ 2,00", "€ 1,50", "€ 2,50", "€ 4,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "GELD-BOOD-SIMPEL-2",
    "explanation": "4 appels × €0,50 = €2,00.",
    "distractorExplanations": {
      "1": "Je hebt 3 appels berekend. 4 × €0,50 = €2,00.",
      "2": "Je hebt 5 appels berekend. 4 × €0,50 = €2,00.",
      "3": "Je hebt 8 appels berekend. 4 × €0,50 = €2,00."
    }
  },
  {
    "id": "GELD-SPAAR-L1-001",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Je hebt € 10,00 gespaard. Je krijgt € 5,00 zakgeld. Hoeveel heb je nu?",
    "options": ["€ 15,00", "€ 5,00", "€ 10,00", "€ 20,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "GELD-SPAAR-SIMPEL-1",
    "explanation": "Je hebt €10 + je krijgt €5 = €15.",
    "distractorExplanations": {
      "1": "Je bent je spaargeld vergeten. €10 + €5 = €15.",
      "2": "Je bent je zakgeld vergeten. €10 + €5 = €15.",
      "3": "Je hebt €5 te veel. €10 + €5 = €15."
    }
  },
  {
    "id": "GELD-SPAAR-L1-002",
    "module": "TijdGeld",
    "difficulty": 103,
    "question": "Een speelgoed kost € 20,00. Je hebt € 12,00. Hoeveel moet je nog sparen?",
    "options": ["€ 8,00", "€ 10,00", "€ 6,00", "€ 32,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "GELD-SPAAR-SIMPEL-2",
    "explanation": "Speelgoed kost €20. Je hebt €12. Je moet nog €20 - €12 = €8 sparen.",
    "distractorExplanations": {
      "1": "Je hebt €2 te veel berekend. €20 - €12 = €8.",
      "2": "Je hebt €2 te weinig berekend. €20 - €12 = €8.",
      "3": "Je hebt opgeteld in plaats van afgetrokken. €20 - €12 = €8."
    }
  }
]
